import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import $t from '../../../i18n'
import SpecialityServicesCard from '../../common/SpecialityServiceCard'
import Alert from '../../common/Alert'
import { capitalize } from 'lodash'
import { isInClinic } from '../../../utils/clinicsUtils'
import { clinicTypes, getClinicImage } from '../../../consts'
import Page from '../../common/Page'
import { filterQueueAppointmentsClinic } from '../../../utils/appointmentsUtils'

import './SpecialityServices.css'

const SpecialityServices = () => {
  const dispatch = useDispatch()
  const [shouldShowAlert, setShouldShowAlert] = useState(false)

  const firstName = useSelector(state => state.profile?.userDetails?.firstName)
  const isInMHClinic = useSelector(state =>
    isInClinic(state, clinicTypes.MENTAL)
  )

  const appointments = useSelector(state => state.appointments?.appointments)
  const isMhApp =
    filterQueueAppointmentsClinic(appointments, clinicTypes.MENTAL)?.length > 0
  const isHtnApp =
    filterQueueAppointmentsClinic(appointments, clinicTypes.HTN)?.length > 0
  const isDmApp =
    filterQueueAppointmentsClinic(appointments, clinicTypes.DIABETES)?.length >
    0

  const renderSpecialityServiceCard = cardProps => {
    const {
      title,
      image,
      buttonText,
      onContinue,
      showDisclaimer,
      descriptionTitle,
      descriptionNotes,
      descriptionPoints,
      descriptionPointsTitle,
      hidden,
      displayCheckedAction,
    } = cardProps

    return (
      <SpecialityServicesCard
        title={title}
        image={image}
        buttonText={buttonText}
        onContinue={onContinue}
        showDisclaimer={showDisclaimer}
        descriptionTitle={descriptionTitle}
        descriptionNotes={descriptionNotes}
        descriptionPoints={descriptionPoints}
        descriptionPointsTitle={descriptionPointsTitle}
        hidden={hidden}
        displayCheckedAction={displayCheckedAction}
      />
    )
  }

  const onContinueMH = () => {
    // If user is in MH clinic and not have already MH appointment
    //  he try to book a fu appointment -> show alert
    if (isInMHClinic && !isMhApp) {
      setShouldShowAlert(true)
      return
    }

    dispatch(Actions.createAction(Actions.MENTALHEALTH_CLICKED))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: Actions.MENTALHEALTH_CLICKED + '_WEB',
        data: { origin: 'specialty services' },
      })
    )
  }

  const onContinueHT = () => {
    dispatch(Actions.createAction(Actions.HYPERTENSION_CLICKED))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: Actions.HYPERTENSION_CLICKED + '_WEB',
        data: { origin: 'specialty services' },
      })
    )
  }

  const onContinueDM = () => {
    dispatch(Actions.createAction(Actions.DIABETES_CLICKED))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: Actions.DIABETES_CLICKED + '_WEB',
        data: { origin: 'specialty services' },
      })
    )
  }

  return (
    <Page
      title={$t('pages.getStarted.specialityServices.specialityServices')}
      className="speciality-services-container grey"
    >
      <div className="speciality-services-card-container">
        {renderSpecialityServiceCard({
          title: $t('pages.getStarted.specialityServices.hypertension.title'),
          image: getClinicImage(clinicTypes.HTN).uri,
          buttonText: !isHtnApp
            ? $t('pages.getStarted.specialityServices.continueButton')
            : $t('pages.getStarted.specialityServices.seeAppointmentsButton'),
          onContinue: onContinueHT,
          showDisclaimer: isHtnApp,
          descriptionTitle: $t(
            'pages.getStarted.specialityServices.hypertension.descriptionTitle'
          ),
          descriptionNotes: '',
          descriptionPointsTitle: $t(
            'pages.getStarted.specialityServices.hypertension.descriptionPointsTitle'
          ),
          descriptionPoints: [
            $t(
              'pages.getStarted.specialityServices.hypertension.descriptionPoint1'
            ),
            $t(
              'pages.getStarted.specialityServices.hypertension.descriptionPoint2'
            ),
            $t(
              'pages.getStarted.specialityServices.hypertension.descriptionPoint3'
            ),
          ],
        })}
        {renderSpecialityServiceCard({
          title: $t('pages.getStarted.specialityServices.mh.title'),
          image: getClinicImage(clinicTypes.MENTAL).uri,
          buttonText: !isMhApp
            ? $t('pages.getStarted.specialityServices.continueButton')
            : $t('pages.getStarted.specialityServices.seeAppointmentsButton'),
          onContinue: onContinueMH,
          showDisclaimer: isMhApp,
          descriptionTitle: $t(
            'pages.getStarted.specialityServices.mh.descriptionTitle'
          ),
          descriptionPointsTitle: $t(
            'pages.getStarted.specialityServices.mh.descriptionPointsTitle'
          ),
          descriptionPoints: [
            $t('pages.getStarted.specialityServices.mh.descriptionPoint1'),
            $t('pages.getStarted.specialityServices.mh.descriptionPoint2'),
            $t('pages.getStarted.specialityServices.mh.descriptionPoint3'),
          ],
        })}
        {renderSpecialityServiceCard({
          title: $t('pages.getStarted.specialityServices.diabetes.title'),
          image: getClinicImage(clinicTypes.DIABETES).uri,
          buttonText: !isDmApp
            ? $t('pages.getStarted.specialityServices.continueButton')
            : $t('pages.getStarted.specialityServices.seeAppointmentsButton'),
          onContinue: onContinueDM,
          showDisclaimer: isDmApp,
          descriptionTitle: $t(
            'pages.getStarted.specialityServices.diabetes.descriptionTitle'
          ),
          descriptionNotes: '',
          descriptionPointsTitle: $t(
            'pages.getStarted.specialityServices.diabetes.descriptionPointsTitle'
          ),
          descriptionPoints: [
            $t(
              'pages.getStarted.specialityServices.diabetes.descriptionPoint1'
            ),
            $t(
              'pages.getStarted.specialityServices.diabetes.descriptionPoint2'
            ),
            $t(
              'pages.getStarted.specialityServices.diabetes.descriptionPoint3'
            ),
          ],
        })}
      </div>
      <Alert
        title={$t(
          'pages.getStarted.specialityServices.mh.followUpSupportMessage',
          { name: capitalize(firstName) }
        )}
        shouldDisplay={shouldShowAlert}
        onOk={() => setShouldShowAlert(false)}
      />
    </Page>
  )
}

export default SpecialityServices
